module.exports = __webpack_public_path__ + "media/fun/fun-7-f13d8029.jpg";